import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { companyService } from 'src/app/services/company.service';
import { Router } from '@angular/router';
import { userDataService } from 'src/app/services/userDataService';

@Component({
  selector: 'app-attendance-status-modal',
  standalone: true,
  imports: [MaterialModule, CommonModule],
 
  templateUrl: './app-attendance-status-modal.component.html',
  styleUrls: ['./app-attendance-status-modal.component.scss']
})
export class AttendanceStatusModalComponent implements OnInit {
  currentStep: 'status' | 'outcome' = 'status';
  selectedStatus: string = '';
  selectedOutcome: number | null = null;
  activityOutcomes: any[] = [];
  isOutcomeRequired: boolean = false;
  isLoading: boolean = false;
  isLoadingOutcomes: boolean = false;
  showReschedule: boolean = true;

  roleUser:'ADMIN'|'USER'='USER'

  constructor(
    public dialogRef: MatDialogRef<AttendanceStatusModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private companyService: companyService,
    private router: Router,
    private dialog: MatDialog,
    private userDataService:userDataService
  ) {
    this.showReschedule = data.editMode;
    this.isOutcomeRequired = data.activity?.is_outcome_required || false;
  }

  ngOnInit() {
    // Pre-load outcomes if the activity requires them
    if (this.data.activity?.is_appointment && this.data.activity?.id) {
      this.preLoadOutcomes();
    }
  }

  async preLoadOutcomes() {
    const user = await this.userDataService.getUserData();
    this.roleUser = user?.role


    try {
      const response: any = await firstValueFrom(
        this.companyService.getActivityTypeOutcomes(this.data.activity.id)
      );
      this.activityOutcomes = response || [];
    } catch (error) {
      console.error('Error pre-loading outcomes:', error);
      this.activityOutcomes = [];
    }
  }

  async selectStatus(status: string) {
    this.selectedStatus = status;
    
    if (status === 'SHOW' && this.data.activity?.is_appointment) {
      // Check if we need to show outcome selection
      this.isLoadingOutcomes = true;
      
      // Load outcomes if not already loaded
      if (this.activityOutcomes.length === 0) {
        await this.loadOutcomes();
      }
      
      this.isLoadingOutcomes = false;
      
      // Show outcome step if outcomes exist
      if (this.activityOutcomes.length > 0) {
        this.currentStep = 'outcome';
        return;
      }
    }
    
    // For NO_SHOW, RESCHEDULED, or SHOW without outcomes, close immediately
    this.dialogRef.close({
      status: status,
      outcome_id: null
    });
  }

  async loadOutcomes() {
    if (!this.data.activity?.id) return;
    
    try {
      const response: any = await firstValueFrom(
        this.companyService.getActivityTypeOutcomes(this.data.activity.id)
      );
      this.activityOutcomes = response || [];
    } catch (error) {
      console.error('Error loading activity outcomes:', error);
      this.activityOutcomes = [];
    }
  }

  selectOutcome(outcomeId: number) {
    this.selectedOutcome = outcomeId;
  }

  goBackToStatus() {
    this.currentStep = 'status';
    this.selectedStatus = '';
    this.selectedOutcome = null;
  }

  async confirmWithOutcome() {
    if (this.isOutcomeRequired && !this.selectedOutcome) {
      return; // Button should be disabled, but double-check
    }

    this.isLoading = true;
    
    // Small delay for better UX
    setTimeout(() => {
      this.dialogRef.close({
        status: this.selectedStatus,
        outcome_id: this.selectedOutcome
      });
    }, 300);
  }

  getDialogTitle(): string {
    switch (this.currentStep) {
      case 'status':
        return 'Past Appointment Status';
      case 'outcome':
        return 'Select Appointment Outcome';
      default:
        return 'Attendance Status';
    }
  }

  goToOutcomeSettings(): void {
    // Close all open dialogs
    this.dialog.closeAll();

    // Navigate to settings page with both tab and subTab parameters
    this.router.navigate(['/settings/profile/company'], {
      queryParams: { tab: 'activities', subTab: 'outcomes' }
    });
  }
}